{
  "feedback-internal-details-page": {
    "buttons": {
      "submit": "PŘEDLOŽIT"
    },
    "text": {
      "comment": "Váš komentář",
      "cleanliness": "Prostředí a čistota",
      "hint": "Pomozte nám prosím zjistit, jak se vám naše služby líbí.",
      "service": "Služba",
      "staff": "Zaměstnanci"
    }
  }
}
